import search from '~/assets/icons/search.svg';
import { playSound, Sound } from '~/assets/sounds';
import { StyledSearchInput, StyledSearchWrapper } from './SearchInput.styled';

interface SearchInputProps {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	style?: React.CSSProperties;
}

const SearchInput = ({
	value,
	onChange,
	placeholder,
	style,
}: SearchInputProps) => {
	return (
		<StyledSearchWrapper $active={value.trim().length > 0} style={style}>
			<StyledSearchInput
				placeholder={placeholder}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				$active={value.trim().length > 0}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
				tabIndex={-1}
			/>
			<img src={search} alt="search" />
		</StyledSearchWrapper>
	);
};

export { SearchInput };
